export default __webpack_public_path__ + "static/Shower-cap-in-suitcase-hack-c4216a17f41177477d04ee4584135777.jpg";